var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail"},[_c('h1',[_vm._v(_vm._s(_vm.list.title))]),_c('span',[_vm._v("技术："+_vm._s(_vm.list.content))]),_c('div',{staticClass:"img"},_vm._l((_vm.list.img),function(item,index){return _c('img',{key:index,staticStyle:{"border":"1px solid #ccc","margin":"5px auto"},attrs:{"src":item,"alt":item}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }